import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('./views/Home.vue'),
        meta: {
            title: 'Home',
            key: 'home'
        }
    },

    {
        path: '/articles',
        name: 'Articles',
        component: () => import('./views/Articles.vue'),
        meta: {
            title: 'Articles',
            key: 'articles'
        }
    },

    {
        path: '/portfolio',
        name: 'Portfolio',
        component: () => import('./views/Portfolio.vue'),
        meta: {
            title: 'Portfolio',
            key: 'portfolio'
        }
    },

    {
        path: '/sermons',
        name: 'Sermons',
        component: () => import('./views/Sermons.vue'),
        meta: {
            title: 'Sermons',
            key: 'sermons'
        }
    },

    {
        path: '/ministries/:id/:title?',
        name: 'MinistryDetail',
        component: () => import('./views/MinistryDetail.vue'),
        meta: {
            title: 'Ministry',
            key: 'ministries'
        }
    },

    {
    path: '/sermons/:id/:title?',
        name: 'SermonDetail',
        component: () => import('./views/SermonDetail.vue'),
        meta: {
            title: 'Sermon',
            key: 'sermons'
        }
    },

    {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component: () => import('./views/ArticleDetail.vue'),
        meta: {
            title: 'Privacy Policy',
            key: 'privacy-policy',
            pageHash: 'privacy-policy',
            hideContact: true
        }
    },

    {
        path: '/terms-and-conditions',
        name: 'TermsConditions',
        component: () => import('./views/ArticleDetail.vue'),
        meta: {
            title: 'Terms & Conditions',
            key: 'terms-and-conditions',
            pageHash: 'terms-and-conditions',
            hideContact: true
        }
    },

    {
        path: '/cookies',
        name: 'Cookies',
        component: () => import('./views/ArticleDetail.vue'),
        meta: {
            title: 'Cookies Policy',
            key: 'cookies',
            pageHash: 'cookies',
            hideContact: true
        }
    },

    {
        path: '/articles/:id/:title?',
        name: 'ArticleDetail',
        component: () => import('./views/ArticleDetail.vue'),
        meta: {
            title: 'Article',
            key: 'blog'
        }
    },

    {
        path: '/pages/:slug',
        name: 'Page',
        component: () => import('./views/ArticleDetail.vue'),
        meta: {
            title: 'Page',
            key: 'page'
        }
    },

    {
        path: '*',
        name: 'NotFound',
        component: () => import('./views/NotFound.vue'),
        meta: {
            title: 'Not Found',
            key: 'not-found'
        }
    }
];

export default new Router({
    mode: 'history',

    base: process.env.VUE_APP_PUBLIC_PATH || '/',

    routes,

    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }

        if (to.hash) {
            return {
                selector: to.hash,
                offset: {
                    x: 0,
                    y: 90
                }
            };
        }

        return {
            x: 0,
            y: 0
        };
    }
});